"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageLevel = void 0;
var LanguageLevel;
(function (LanguageLevel) {
    LanguageLevel[LanguageLevel["A1"] = 0] = "A1";
    LanguageLevel[LanguageLevel["A2"] = 1] = "A2";
    LanguageLevel[LanguageLevel["B1"] = 2] = "B1";
    LanguageLevel[LanguageLevel["B2"] = 3] = "B2";
    LanguageLevel[LanguageLevel["C1"] = 4] = "C1";
    LanguageLevel[LanguageLevel["C2"] = 5] = "C2";
})(LanguageLevel || (exports.LanguageLevel = LanguageLevel = {}));
//# sourceMappingURL=LanguageLevels.js.map